import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AFCriminalHistoryDomain, AFFitnessAndProprietyDomain } from '../model/af.model';
import { AuthService } from './auth.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CriminalHistoryService {

  constructor(private readonly userService: AuthService, private readonly http: HttpClient) {
  }

  getCriminalHistory(isOUS: boolean): Observable<AFCriminalHistoryDomain> {
    return this.http.post<AFCriminalHistoryDomain>(environment.api_uri + 'getCriminalHistory', { 'verifyId': this.userService.getVerifyId(), 'isOUS': isOUS }).pipe(
      map(response => {

        if (response.criminalOffenseList) {
          response.criminalOffenseList.forEach(item => {
            if (item.dateOfArrest) {
              if (item.dateOfArrest) {
                item.dateOfArrest = new Date(item.dateOfArrest);
              }
            }

            if (item.dateOfDisposition) {
              if (item.dateOfDisposition) {
                item.dateOfDisposition = new Date(item.dateOfDisposition);
              }
            }
            if (item.dateOfOffense) {
              if (item.dateOfOffense) {
                item.dateOfOffense = new Date(item.dateOfOffense);
              }
            }

            if (item.levelOfOffense) {
              item.levelOfOffense = item.levelOfOffense + "";
            }
            if (item.usState) {
              item.usState = item.usState + "";
            }

            if (item.disposition) {
              item.disposition = item.disposition + "";
            }

            if (item.country) {
              item.country = item.country + "";
            }
          });
        }

        return response;
      }));
  }

  submitCriminalHistory(AFCriminalHistoryDomain): Observable<AFCriminalHistoryDomain> {
    const requestUrl = environment.api_uri + 'saveCriminalHistory';

    //set NMLS number to blank
    if (AFCriminalHistoryDomain.safeRegistrationFlag != -1 && AFCriminalHistoryDomain.usCriminalSafeRegistration == 0) {
      AFCriminalHistoryDomain.usCriminalNMLSNumber = null;
    }

    AFCriminalHistoryDomain.criminalOffenseList.forEach(item => {

      if (item.dateOfArrest) {
        item.dateOfArrest = moment(item.dateOfArrest).format('MM/DD/YYYY');
      }

      if (item.dateOfDisposition) {
        item.dateOfDisposition = moment(item.dateOfDisposition).format('MM/DD/YYYY');
      }

      if (item.dateOfOffense) {
        item.dateOfOffense = moment(item.dateOfOffense).format('MM/DD/YYYY');
      }

      if (item.offenseOrRegulatoryAction && item.offenseOrRegulatoryAction != 'Other') {
        item.othrCmtOffenseType = '';
      }

      if (item.levelOfOffense && item.levelOfOffense != '16') {
        item.othrCmtLevelOfOffense = '';
      }

      if (item.disposition && item.disposition != '9') {
        item.othrCmtDisposition = '';
      }
    });

    return this.http.post<AFCriminalHistoryDomain>(requestUrl, AFCriminalHistoryDomain);
  }

  getFitnessAndProprietyQuestions(): Observable<AFFitnessAndProprietyDomain> {
    return this.http.post<AFFitnessAndProprietyDomain>(environment.api_uri + 'getFitnessAndProprietyQuestions', { 'verifyId': this.userService.getVerifyId() });
  }

  submitFitnessAndProprietyQuestions(afFitnessAndProprietyDomain): Observable<AFFitnessAndProprietyDomain> {
    const requestUrl = environment.api_uri + 'saveFitnessAndProprietyQuestions';
    return this.http.post<AFFitnessAndProprietyDomain>(requestUrl, afFitnessAndProprietyDomain);
  }
}